import { z } from 'zod';

export type GatewayType = z.infer<typeof gatewayTypeSchema>;
export const gatewayTypeSchema = z.union([z.literal('gateway'), z.literal('gatewayPro')]);
